import React, { useEffect } from "react";

const Intro = () => {
  return (
    <div className="intro">
      <div className="container-fluid center">
        <div className="wrapper center">
          <div className="title">Sagar naik</div>
          <div className="intro-subtitle">
            Full-Stack Engineer | Software Developer
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
